export const colors = {
  primary: "orange",
  secondary: "#0a0927",
  layout: "brown",
};
